import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./ErrorBoundary.tsx";
import { validateEnvironmentVariables } from "./utils/envCheck.ts";
import "./index.css";

// ═══════════════════════════════════════════════════════════════
// GLOBAL ERROR HANDLERS - Catch all unhandled errors
// ═══════════════════════════════════════════════════════════════

// Handle uncaught JavaScript errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.error('🚨 UNCAUGHT ERROR DETECTED');
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.error('Message:', message);
  console.error('Source:', source);
  console.error('Line:', lineno, 'Column:', colno);
  console.error('Error Object:', error);
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  
  // Don't prevent default error handling
  return false;
};

// Handle unhandled promise rejections
window.onunhandledrejection = (event) => {
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.error('🚨 UNHANDLED PROMISE REJECTION');
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.error('Reason:', event.reason);
  console.error('Promise:', event.promise);
  console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  
  // Prevent default handling (which would log to console again)
  event.preventDefault();
};

// ═══════════════════════════════════════════════════════════════
// ENVIRONMENT VALIDATION - Check all required env vars
// ═══════════════════════════════════════════════════════════════

try {
  validateEnvironmentVariables();
} catch (error) {
  console.error('Failed to validate environment variables:', error);
  // App will still try to render but with error boundary
}

// ═══════════════════════════════════════════════════════════════
// APP INITIALIZATION
// ═══════════════════════════════════════════════════════════════

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element not found. Make sure index.html has a div with id="root"');
}

createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
